import * as _ from 'lodash';
import { fetchWrapper } from './FetchWrapper';

/**
 * Enum option structure returned from backend
 * Note: We use 'value' for both the actual value and display text in dropdowns
 */
export interface EnumOption {
    value: string;
    label: string;
}

/**
 * API caller for fetching enum values from public endpoints
 * These endpoints do not require authentication
 */
export const EnumApiCaller = {
    requestBaseUrl: '/api/public/enum',

    /**
     * Get OrderStatus enum options
     * @returns Array of { value, label } for order statuses
     * Example: [{ value: 'PENDING', label: 'Pending' }, ...]
     */
    getOrderStatusOptions: async (): Promise<EnumOption[]> => {
        const response = await fetchWrapper.get(`${EnumApiCaller.requestBaseUrl}/orderStatus`, '');
        return EnumApiCaller.handleResponseResultList(response);
    },

    /**
     * Get PaymentStatus enum options
     * @returns Array of { value, label } for payment statuses
     * Example: [{ value: 'PENDING', label: 'Pending' }, ...]
     */
    getPaymentStatusOptions: async (): Promise<EnumOption[]> => {
        const response = await fetchWrapper.get(`${EnumApiCaller.requestBaseUrl}/paymentStatus`, '');
        return EnumApiCaller.handleResponseResultList(response);
    },

    /**
     * Get RefundStatus enum options
     * @returns Array of { value, label } for refund statuses
     * Example: [{ value: 'NOT_REFUNDED', label: 'Not Refunded' }, ...]
     */
    getRefundStatusOptions: async (): Promise<EnumOption[]> => {
        const response = await fetchWrapper.get(`${EnumApiCaller.requestBaseUrl}/refundStatus`, '');
        return EnumApiCaller.handleResponseResultList(response);
    },

    /**
     * Get PaymentType enum options
     * @returns Array of { value, label } for payment types
     * Example: [{ value: 'ORDER_PAYMENT_BUYER', label: 'Order Payment Buyer' }, ...]
     */
    getPaymentTypeOptions: async (): Promise<EnumOption[]> => {
        const response = await fetchWrapper.get(`${EnumApiCaller.requestBaseUrl}/paymentType`, '');
        return EnumApiCaller.handleResponseResultList(response);
    },

    /**
     * Get RefundType enum options
     * @returns Array of { value, label } for refund types
     * Example: [{ value: 'ORDER_REFUND_BUYER', label: 'Order Refund Buyer' }, ...]
     */
    getRefundTypeOptions: async (): Promise<EnumOption[]> => {
        const response = await fetchWrapper.get(`${EnumApiCaller.requestBaseUrl}/refundType`, '');
        return EnumApiCaller.handleResponseResultList(response);
    },

    /**
     * Get BalanceType enum options
     * @returns Array of { value, label } for balance types
     * Example: [{ value: 'CREDIT', label: 'Credit' }, ...]
     */
    getBalanceTypeOptions: async (): Promise<EnumOption[]> => {
        const response = await fetchWrapper.get(`${EnumApiCaller.requestBaseUrl}/balanceType`, '');
        return EnumApiCaller.handleResponseResultList(response);
    },

    /**
     * Extract result array from API response
     * @param response - API response object
     * @returns Array of enum options or empty array if error
     */
    handleResponseResultList: (response: any): EnumOption[] => {
        return _.get(response, 'result', []);
    }
};
